export const getSecondsFromMidnight = (date: Date) =>
  (date.getHours() * 60 + date.getMinutes()) * 60;
